// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1086) return "static/chunks/1086.9245095ee773669f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5730 ? "44530001" : chunkId) + "-" + {"5369":"09b3402eeb3679b7","5730":"901e254161089807"}[chunkId] + ".js";
};